<script>
    import Btn from "../components/Btn.svelte";
    import Gap from "../components/Gap.svelte";
    import { t } from "../helpers/translation";

    export let params = null;
    console.error("404 page: ", params); // path...
</script>

<center>
    <Gap height="16rem" />
    <h4>
        {@html $t("page.404.subline")}
    </h4>
    <h1>
        {@html $t("page.404.headline")}
    </h1>
    <Gap height="2rem" />
    <Btn href="/" arrow_left icon_left>
        {@html $t("page.404.btn.home")}
    </Btn>
</center>
